import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=cb182448&scoped=true&"
import script from "./activate.vue?vue&type=script&lang=js&"
export * from "./activate.vue?vue&type=script&lang=js&"
import style0 from "./activate.vue?vue&type=style&index=0&id=cb182448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb182448",
  null
  
)

export default component.exports